import _defineProperty from '@babel/runtime/helpers/defineProperty';
import * as React from 'react';
import { Box } from '../Box/Box.js';
import { useDivider } from './useDivider.js';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

/** Divider is a thin line that helps separate and group content in the layouts. */
var Divider = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var _useDivider = useDivider(_objectSpread(_objectSpread({}, props), {}, {
      ref: ref
    })),
    dividerProps = _useDivider.dividerProps;
  return /*#__PURE__*/React.createElement(Box, dividerProps);
});
Divider.defaultProps = {
  direction: 'horizontal',
  color: 'base.subtle'
};
var DividerMemoized = /*#__PURE__*/React.memo(Divider);
DividerMemoized.displayName = 'Divider';

export { DividerMemoized as Divider };
//# sourceMappingURL=Divider.js.map
